import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { Redirect } from "react-router";
import { Routes } from "../../../../constants/routes";
import Typography from "@material-ui/core/Typography";
import Loading from "../../../../components/Loading";
import { Field } from "react-final-form";
import { FormRenderProps } from "react-final-form";
import PasswordInput from "../../../../components/PasswordInput";
import Button from "../../../../components/Button";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
}));

const ResetPasswordForm: FC<FormRenderProps> = ({
  submitting,
  submitError,
  handleSubmit,
  submitSucceeded,
}) => {
  const classes = useStyles();
  if (submitSucceeded)
    return (
      <Redirect
        to={{
          pathname: `/${Routes.LOGIN}`,
          state: {
            message: {
              color: "inherit",
              text: "Your password was reset.",
            },
          },
        }}
      />
    );
  return (
    <form onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      {submitting && <Loading />}
      <Typography component="div" className={classes.root}>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            name="password"
            label="New password"
            placeholder="Must have at least 8 characters"
            component={PasswordInput}
          />
        </Typography>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            label="Repeat Password"
            placeholder="Must have at least 8 characters"
            component={PasswordInput}
            name="password_confirmation"
          />
        </Typography>
        <Typography
          align="center"
          component="div"
          className={classes.formControl}
        >
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            fullWidth
            disabled={submitting}
          >
            Reset
          </Button>
        </Typography>
      </Typography>
    </form>
  );
};

export default ResetPasswordForm;
